window.app = window.app || {};

window.app.blogList = {
  el: {
    section: document.querySelector('.mt-blog-list'),
    sectionHeader: document.querySelector('.mt-blog-list__heading'),
    carousel: document.querySelector('.mt-blog-list__carousel .swiper'),
    articlesLinks: document.querySelectorAll('.mt-blog-item a')
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;

    _this.slider = new Swiper(_this.el.carousel, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });

    // Additional DL events
    _this.el.articlesLinks.forEach(link => {
      const articleTitle = link.closest('.mt-blog-item').querySelector('.mt-blog-item__title');
      articleTitle && link.addEventListener('click', () => {
        if (_this.el.section.id === 'success-stories') {
          app.dl.customClick(articleTitle.innerText, { location: _this.el.sectionHeader?.innerText });
        } else {
          app.dl.customClick(articleTitle.innerText, { type: 'Blog post', location: _this.el.sectionHeader?.innerText });
        }
      });
    });
  }
}
window.app.blogList.init();